import { Annotation } from 'ckeditor5-premium-features';
import { useSearchParams } from 'react-router-dom';

export const useAnnotationHighlighting = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const handleHighlighting = (
    annotations: any,
    identifierPredicate: (annotation: Annotation) => boolean,
    htmlSelector: string,
  ) =>
    setTimeout(() => {
      const visibleAnnotations = annotations.collection.filter(
        (annotation: Annotation) => annotation.isVisible,
      );
      if (visibleAnnotations.length === 0) {
        return;
      }
      const annotationToActivate = visibleAnnotations.find(identifierPredicate);
      if (annotationToActivate) {
        annotations.activate(annotationToActivate);
        const targetElement = document.querySelector(htmlSelector);
        if (targetElement) {
          targetElement.scrollIntoView({
            block: 'center',
            behavior: 'smooth',
          });
        }
      }
      searchParams.delete('targetId');
      setSearchParams(searchParams);
    }, 250);
  return { handleHighlighting };
};
